import { put, takeEvery } from "redux-saga/effects"
import { get, post } from "helpers/api_helper"
import {
  addBookingFaied,
  getBookingFailed,
  getBookingSuccess,
  getBookingTypeFailed,
  getBookingTypeSuccess,
} from "./actions"
import { showSavingModal, hideSavingModal, setIsOutdated } from "../actions"
import { ADD_BOOKING, GET_BOOKING, GET_BOOKING_TYPE } from "./actionTypes"
import { showToast } from "utils"

function* getBookingTypes({ payload: { params } }) {
  try {
    const response = yield get("/admin/booking-type", { params })
    yield put(getBookingTypeSuccess(response))
  } catch (error) {
    yield put(getBookingTypeFailed(error))
  }
}

function* addBooking({ payload: params }) {
  try {
    yield put(showSavingModal())
    yield post("/admin/booking/menu-item", params)
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addBookingFaied(error))
  }
}

function* getBooking({ payload: { params } }) {
  try {
    const response = yield get("/admin/booking/menu-item", { params })
    yield put(getBookingSuccess(response))
  } catch (error) {
    yield put(getBookingFailed(error))
  }
}

function* bookingsSaga() {
  yield takeEvery(GET_BOOKING_TYPE, getBookingTypes)
  yield takeEvery(ADD_BOOKING, addBooking)
  yield takeEvery(GET_BOOKING, getBooking)
}

export default bookingsSaga
